export enum FolderType {
  Chart = 'chart',
  Dashboard = 'dashboard',
}

export interface Folder {
  id: string;
  name: string;
  folder_type: FolderType;
  items: string[];
}
